module.exports = __webpack_public_path__ + "src/assets/img/car_two-signal.c05e8c3c.png";